import { trackAbTestV2Variant, getAbTestV2 } from 'dibs-buyer-layout/exports/clientABTestV2';
import { useEffect } from 'react';

export const LIVE_CHAT_AB_TEST_NAME = 'Live-Chat-Make-Offer';

export const isLiveChatMakeOfferABTestVariant = (): boolean =>
    getAbTestV2(LIVE_CHAT_AB_TEST_NAME)?.variant === 'variant';

export const useLiveChatMakeOfferABTestTracking = ({
    isCheckoutReady,
    canShowLiveChat,
}: {
    isCheckoutReady: boolean;
    canShowLiveChat: boolean;
}): void => {
    useEffect(() => {
        if (isCheckoutReady && canShowLiveChat) {
            trackAbTestV2Variant(LIVE_CHAT_AB_TEST_NAME);
        }
    }, [isCheckoutReady, canShowLiveChat]);
};
